<template>
  <div class="message-editor">
    <div class="section-header">
      <span class="label">{{ label }} ({{ list.length }}/{{ max }})</span>
      <slot name="extra"></slot>
    </div>
    <div
      v-for="(_, i) in list"
      :key="'msg-' + i"
      class="input-row"
      :class="{ 'is-duplicate': isDuplicate(i) }"
    >
      <emoji-input
        :placeholder="placeholder"
        :type="inputType"
        :value="list[i]"
        :index="i"
        @input="handleInput"
        class="flex-1"
      ></emoji-input>
      <div class="input-actions">
        <i
          class="el-icon-delete"
          @click="deleteItem(i)"
          v-if="list.length > 1"
        ></i>
      </div>
      <span
        v-if="isDuplicate(i)"
        class="duplicate-tip"
      >内容重复</span>
    </div>
    <div class="section-footer">
      <el-button
        type="text"
        size="small"
        @click="addItem"
        :disabled="list.length >= max"
      >
        <i class="el-icon-plus"></i>
        {{ addButtonText }}
      </el-button>
    </div>
  </div>
</template>

<script>
import emojiInput from '@/views/adManagement/createAd/components/emojiInput';

export default {
  name: 'MessageEditor',
  components: {
    emojiInput,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Array,
      default: () => [''],
    },
    max: {
      type: Number,
      default: 5,
    },
    placeholder: {
      type: String,
      default: '请输入正文',
    },
    label: {
      type: String,
      default: '正文',
    },
    addButtonText: {
      type: String,
      default: '添加正文',
    },
    inputType: {
      type: String,
      default: 'textarea',
    },
  },
  computed: {
    list() {
      return this.value?.length ? this.value : [''];
    },
  },
  methods: {
    // 检测当前行是否与其他行重复（忽略空值）
    isDuplicate(index) {
      const val = this.list[index];
      if (!val || !val.trim()) return false;
      const trimmed = val.trim();
      return this.list.some((v, i) => i !== index && v && v.trim() === trimmed);
    },
    handleInput(val, index) {
      const newList = [...this.list];
      newList.splice(index, 1, val);
      this.$emit('change', newList);
    },
    addItem() {
      if (this.list.length >= this.max) return;
      if (this.list.some((v) => !v || !v.trim())) {
        this.$message.warning('请先填写已有的空白项');
        return;
      }
      const newList = [...this.list, ''];
      this.$emit('change', newList);
    },
    deleteItem(index) {
      if (this.list.length <= 1) return;
      const newList = [...this.list];
      newList.splice(index, 1);
      this.$emit('change', newList);
    },
  },
};
</script>

<style lang="scss" scoped>
.message-editor {
  .section-header {
    display: flex;
    align-items: center;
    margin-bottom: 8px;

    .label {
      color: #333;
      font-weight: 500;
      margin-right: 12px;
    }
  }

  .section-footer {
    display: flex;
    align-items: center;
    margin-top: 4px;

    .el-button {
      padding-left: 0;
      padding-right: 0;
    }
  }

  .input-row {
    display: flex;
    align-items: flex-start;
    margin-bottom: 8px;
    position: relative;
    flex-wrap: wrap;

    .flex-1 {
      flex: 1;
    }

    .input-actions {
      display: flex;
      align-items: center;
      margin-left: 8px;
      padding-top: 8px;

      i {
        cursor: pointer;
        font-size: 16px;
        color: #999;

        &:hover {
          color: #f56c6c;
        }
      }
    }

    .duplicate-tip {
      width: 100%;
      font-size: 12px;
      color: #e6a23c;
      line-height: 1;
      padding-top: 2px;
      padding-left: 2px;
    }

    &.is-duplicate {
      ::v-deep .el-input__inner,
      ::v-deep .el-textarea__inner {
        border-color: #e6a23c;
      }
    }
  }

  ::v-deep .el-textarea__inner {
    min-height: 50px !important;
    resize: vertical;
  }
}
</style>
